import api from "./api";
import publicApi from "./checkout/publicApi";
import { FirebaseAuthentication } from '@capacitor-firebase/authentication'
import type { AxiosError } from 'axios'

type ApiErrorResponse = {
  status_code?: number
}

const getErrorStatus = (error: unknown) => {
  if (!error || typeof error !== 'object') {
    return undefined
  }
  const axiosError = error as AxiosError<ApiErrorResponse>
  return axiosError.response?.data?.status_code || axiosError.response?.status
}

export const userAuth = async () => {
  try {
    const res = await api.get('user/auth/')
    return res.data
  } catch (error: unknown) {
    const status = getErrorStatus(error)
    if (status !== 401 && status !== 403) {
      throw error
    }

    const { user } = await FirebaseAuthentication.getCurrentUser()
    if (!user) {
      throw error
    }

    await FirebaseAuthentication.getIdToken({ forceRefresh: true })
    const retryRes = await api.get('user/auth/')
    return retryRes.data
  }
};

export const userExists = async (email: string) => {
  const res = await publicApi.get("user/exists", { params: { email } });
  console.log(res.data);
  return res.data;
};

export const registerUser = async (data: {
  email: string;
  password: string;
  full_name: string;
  phone_number: string;
  address: string;
  promotion_opt_in: boolean;
  emergency_contact_phone_number: string;
  emergency_contact_name: string;
}) => {
  const res = await publicApi.post("user/", { ...data });
  return res.data;
};

export const validToken = async (token: string) => {
  const res = await publicApi.get("user/auth", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res.data;
};

export const sendResetEmail = async (email: string) => {
  const res = await publicApi.post(
    "user/token-mail/",
    { email: email },
    {
      params: {
        email: email,
      },
    }
  );

  return res.data;
};

export const changePassword = async (data: {
  token: string;
  password: string;
}) => {
  const res = await publicApi.put(
    "user/edit/",
    {
      password: data.password,
    },
    {
      headers: {
        Authorization: `Bearer ${data.token}`,
      },
    }
  );
  return res.data;
};
